/*
"premier_league_channels":"{ 
    "mexico": [1042215,1041505,1042216,1041506,1041507,1041508,1041509,1041510,1039705,1042217], 
    "panama":[1039754,1041549,1039755,1041550,1039756,1039757,1039758,1039759,1042276,1042277], 
    "costarica":[1042278,1041551,1039760,1041552,1039761,1039762,1039763,1041553,1042279,1039764], 
    "guatemala":[1041519,1042232,1041520,1042234,1039718,1042236,1039720,1042237,1039721], 
    "honduras":[1039747,1039748,1041547,1039749,1039750,1039751,1041548,1039752,1039753,1042275], 
    "nicaragua":[1039765,1041554,1039766,1042281,1039767,1039768,1041555,1039769,1042282,1039770], 
    "elsalvador":[1039722,1042238,1039723,1041521,1042239,1042240,1041522,1039724,1042241,1041523], 
    "dominicana":[1042283,1039771,1041556,1042284,1042285,1039772,1042301,1041566,1042302,1042303] 
}"
*/
import Utils from './../../utils/Utils';

const apaKey = 'premier_league_channels'
const apaKeyDefaultValue = null;
// const apaKeyDefaultValue = {"mexico": [1042215,1041505,1042216,1041506,1041507,1041508,1041509,1041510,1039705,1042217], "panama":[1039754,1041549,1039755,1041550,1039756,1039757,1039758,1039759,1042276,1042277], "costarica":[1042278,1041551,1039760,1041552,1039761,1039762,1039763,1041553,1042279,1039764], "guatemala":[1041519,1042232,1041520,1042234,1039718,1042236,1039720,1042237,1039721], "honduras":[1039747,1039748,1041547,1039749,1039750,1039751,1041548,1039752,1039753,1042275], "nicaragua":[1039765,1041554,1039766,1042281,1039767,1039768,1041555,1039769,1042282,1039770], "elsalvador":[1039722,1042238,1039723,1041521,1042239,1042240,1041522,1039724,1042241,1041523], "dominicana":[1042283,1039771,1041556,1042284,1042285,1039772,1042301,1041566,1042302,1042303] }

const getApaKey = function (key, defaultValue) {
    return Utils.getApaMetadataKey(key, defaultValue);
};

const getSupportedStream = (platform, isTv, groupId, supportedStream) => {

    if(Utils.isNullOrUndefined(platform)) return supportedStream; // platform trae valor
    if(!isTv) return supportedStream; // isTV es 
    if(!Utils.isNumeric(groupId)) return supportedStream; // no es group id válido
    groupId = parseInt(groupId); // Group ID a entero/numérico

    // Recuperar la llave
    const apaValue = getApaKey(apaKey, apaKeyDefaultValue);
    
    if(!Utils.isArray(apaValue)) return supportedStream; // no es llave value válido

    const _supportedStream = {...supportedStream};
    if(apaValue.indexOf(groupId) !== -1) {
        _supportedStream['live'] = ["smooth_streaming"];
    }

    return _supportedStream;
};

const ForcedStreamUtil = {
    getSupportedStream
};

export { ForcedStreamUtil };


// WEBPACK FOOTER //
// ./src/AAF/ForcedSupportedStream/ForcedStreamUtil.js